export { InputPasswordIcon } from './component';
